import { alpha } from '@mui/system'

export const AppBlack = '#000000'
export const AppBorderGrey = '#E6E6E6'
export const AppBorderGreyV2 = '#EDEEF3'
export const AppGreen = '#15CA84'
export const AppGreen07 = '#15CA8412'
export const AppGreenBg = '#89D3AB1A'
export const AppGreenBorder = '#13A85733'
export const AppGreenLight = 'hsla(157, 81%, 44%, 0.07)'
export const AppGrey = '#E9EAED'
export const AppLightBlue = '#8F96A3'
export const AppTextDisabled = '#BCC0C9'
export const AppWhite = '#FFFFFF'
export const BorderColor = '#E1E4EB'
export const Boxbg = '#EEF2F1'
export const DarkGray = '#4D596E'
export const ErrorBg = '#FCF2F4'
export const ErrorColor = '#CA0024'
export const Golden = '#CC9A1A'
export const GrayText = '#696C74'
export const HomeBg = '#F1F2F4'
export const ImageBg = '#FAFAFA'
export const InputIconGrey = '#8A9792'
export const LabelGrey = '#8E95A4'
export const LightBlue = '#4E6288'
export const LightRed = '#EA5353'
export const LineColor = '#F3F3F3'
export const NewGrey = '#F3F5F7'

export const DangerAlertBgColor = '#CA00240D'
export const DangerAlertBorderColor = '#CA002433'
export const SuccessAlertBgColor = '#15CA840D'
export const SuccessAlertBorderColor = '#15CA8433'

export const AvatarBg = alpha('#50D3874D', 0.3)
export const OpeacityGreen = alpha(AppGreen, 0.1)
export const OpacityGolden = alpha(Golden, 0.1)
export const OpeacityGreen_5 = alpha(AppGreen, 0.05)
